// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QtijLJ{position:absolute;top:-9000px;left:-9000px;font-family:initial}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"utility-input": `QtijLJ`,
	"utilityInput": `QtijLJ`
};
export default ___CSS_LOADER_EXPORT___;
